/** Small controlled input writing a LoroText as a whole (captions, titles; spec §7.4). */
import { LoroMap, LoroText } from "loro-crdt";
import { useState } from "react";
import type { DocHandle } from "../sync/docManager";
import { useLoroSelector } from "../sync/hooks";

export function bodyMap(node: { data: LoroMap }): LoroMap | null {
  const b = node.data.get("body");
  return b instanceof LoroMap ? b : null;
}

export function ensureText(map: LoroMap, key: string): LoroText {
  const t = map.get(key);
  if (t instanceof LoroText) return t;
  return map.setContainer(key, new LoroText());
}

export function LoroTextInput({ handle, map, field, placeholder, readOnly, className, testId }: { handle: DocHandle; map: LoroMap; field: string; placeholder?: string; readOnly: boolean; className?: string; testId?: string }) {
  const value = useLoroSelector(handle.doc, () => {
    const t = map.get(field);
    return t instanceof LoroText ? t.toString() : "";
  }) ?? "";
  const [draft, setDraft] = useState<string | null>(null);
  return (
    <input
      className={className ?? "w-full bg-transparent text-sm text-neutral-600 outline-none placeholder:text-neutral-400 dark:text-neutral-300"}
      placeholder={placeholder}
      value={draft ?? value}
      readOnly={readOnly}
      data-testid={testId}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        if (draft !== null && draft !== value) {
          ensureText(map, field).update(draft);
          handle.doc.commit();
        }
        setDraft(null);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") (e.target as HTMLInputElement).blur();
      }}
    />
  );
}
